import React from 'react';
// Import icons from react-icons instead of lucide-react to match the project's icon usage
import { FaBrain, FaBullseye, FaClock } from 'react-icons/fa';

const BasketStats = ({ basket }) => {
  if (!basket) return null;

  // Calculate stats from basket data
  const totalTopics = basket.topics?.length || 0;
  const completedTopics = basket.topics?.filter(topic => topic.is_ripe)?.length || 0;
  const progressPercentage = totalTopics > 0 ? (completedTopics / totalTopics) * 100 : 0;
  const lastUpdated = basket.updated_at ? new Date(basket.updated_at).toLocaleDateString() : 'Not started';

  // Simple mastery score calculation
  const masteryScore = Math.round((completedTopics / Math.max(totalTopics, 1)) * 100);

  return (
    <div className="bg-white rounded-xl border-2 border-neutral-900 p-4 mb-6">
      {/* Main stats grid */}
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div className="flex flex-col items-center justify-center p-3 bg-cranberry-50 rounded-lg">
          <FaBullseye className="w-5 h-5 text-cranberry-600 mb-1" />
          <span className="text-lg font-semibold text-cranberry-900">{totalTopics}</span>
          <span className="text-xs text-cranberry-600">Total Topics</span>
        </div>
        
        <div className="flex flex-col items-center justify-center p-3 bg-butter-50 rounded-lg">
          <FaBrain className="w-5 h-5 text-butter-600 mb-1" />
          <span className="text-lg font-semibold text-butter-900">{masteryScore}%</span>
          <span className="text-xs text-butter-600">Mastery</span>
        </div>

        <div className="flex flex-col items-center justify-center p-3 bg-blue-50 rounded-lg">
          <FaClock className="w-5 h-5 text-blue-600 mb-1" />
          <span className="text-sm font-semibold text-blue-900">{lastUpdated}</span>
          <span className="text-xs text-blue-600">Last Updated</span>
        </div>
      </div>

      {/* Progress bar */}
      <div className="space-y-2">
        <div className="flex justify-between text-sm text-neutral-600">
          <span>Progress</span>
          <span>{completedTopics}/{totalTopics} topics mastered</span>
        </div>
        <div className="w-full bg-neutral-100 rounded-full h-2">
          <div 
            className="bg-cranberry-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default BasketStats; 